import store from '@/store';
import aws_config from "../aws-config";

const auth = {
    async setToken(code, redirect_uri) {

        var domain = aws_config().DOMAIN;
        var grant_type = "authorization_code";
        var client_id = aws_config().CLIENT_ID;

        const postRequest = 'https://' + domain + '/oauth2/token';

        const postdata = {
            "grant_type": grant_type,
            "client_id": client_id,
            "code": code,
            "redirect_uri": redirect_uri
        }

        const formBody = Object.keys(postdata).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(postdata[key])).join('&');

        await fetch(postRequest, {
            method: 'POST',
            headers: {
                'Content-type': 'application/x-www-form-urlencoded'
            },
            body: formBody
        }).then(response => {
            response.json().then(res => {
                store.dispatch('authenticate', {
                    accessToken: res.access_token,
                    idToken: res.id_token,
                    refreshToken: res.refresh_token,
                    expiresIn: res.expires_in
                })
            });
        }).catch(e => {
            console.log(e)
        })
    },

    async getRefreshToken() {
        var domain = aws_config().DOMAIN;

        const postRequest = 'https://' + domain + '/oauth2/token';

        const postdata = {
            "grant_type": "refresh_token",
            "client_id": aws_config().CLIENT_ID,
            "refresh_token": store.state.auth.refreshToken
        }

        const formBody = Object.keys(postdata).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(postdata[key])).join('&');

        const fullfilledResponse = await fetch(postRequest, {
            method: 'POST',
            headers: {
                'Content-type': 'application/x-www-form-urlencoded'
            },
            body: formBody
        })
        return fullfilledResponse;
    }
}

export default auth;
